<div class="row mb-3">
    <div class="col-8 col-lg-8">
      <mat-label class="heading">Edit Undergraduate</mat-label>
    </div>
    <div class="col-4 col-lg-4">
      <div class="d-flex justify-content-end">
        <mat-icon (click)="closeNotif()">close</mat-icon>
      </div>
    </div>
  </div>
  
  <form [formGroup]="editUndergraduateForm">
    <div class="row">
      <div class="col-lg-4">
        <mat-form-field appearance="outline" [style.width.%]="100">
            <mat-label>School</mat-label>
            <input matInput formControlName="school" appNoLeadingSpaces/>
          </mat-form-field>
          <mat-hint class="filipino-translation-hint mb-2"
          >Paaralan</mat-hint
        >
      </div>
      <div class="col-lg-4">
        <mat-form-field appearance="outline" [style.width.%]="100">
            <mat-label>Course</mat-label>
            <input matInput formControlName="course" appNoLeadingSpaces/>
          </mat-form-field>
          <mat-hint class="filipino-translation-hint mb-2"
          >Kurso</mat-hint
        >
      </div>
      <div class="col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Year Attended</mat-label>
          <input
            matInput
            placeholder="YYYY"
            [matDatepicker]="datePicker"
            formControlName="yearAttended"
            appNoLeadingSpaces
            (focus)="datePicker?.open()"
            readonly="true"
            [min]="minDate"
            [max]="maxDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="datePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #datePicker
            color="primary"
            startView="multi-year"
            (yearSelected)="
              onYearSelectedUndergraduate($event, datePicker)
            "
          ></mat-datepicker>
        </mat-form-field>
        <mat-hint class="filipino-translation-hint mb-2"
        >Taon na Dumalo</mat-hint
      >
      </div>
    </div>
    <div class="row mt-2">
        <div *ngIf="successMessage" class="success-message">
          {{ successMessage }}
        </div>
      </div>
      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>

      <mat-progress-bar mode="indeterminate" *ngIf="isUndergraduateBeingUpdated" class="mt-3 mb-3"></mat-progress-bar>

      <div class="row">
        <div class="d-flex justify-content-end mt-3 mb-1">
          <button mat-raised-button color="primary" class="text-white" (click)="updateUndergraduate()" [disabled]="isUndergraduateDisabled">Update</button>
        </div>
      </div>
  </form>
  